import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { SelfExcludeComponent } from './self-exclude.component';
import { SuccessMessageComponent } from 'src/app/components/success-message/success-message.component';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { ServicesSharedModule } from 'src/app/services/services-shared.module';


@NgModule({
  declarations: [
    SelfExcludeComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
    ServicesSharedModule
  ]
})
export class SelfExcludeModule { }